import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinic, VetDoctor, VImage} from "../../models/vet-clinic.model";
import {VetDoctorVetVisitType, VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {VetDoctorVetVisitTypeService} from "../../providers/vet-doctor-vet-visit-type.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Router} from "@angular/router";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";
import {Client} from "../../models/client.model";
import {EMPTY, Subscription} from "rxjs";
import {VetClinicPetSpeciesService} from "../../providers/vet-clinic-pet-species.service";
import {VetClinicPetSpecies} from "../../models/vet-clinic-pet-species.model";
import {PetSpeciesGroup} from "../../models/pet-species-group.model";
import {finalize, switchMap, tap} from "rxjs/operators";
import {SelectSpeciesModalComponent} from "../select-species-modal/select-species-modal.component";

@Component({
  selector: 'app-edit-vet-doctor-vet-visit-type',
  templateUrl: './edit-vet-doctor-vet-visit-type.component.html',
  styleUrls: ['./edit-vet-doctor-vet-visit-type.component.scss'],
})
export class EditVetDoctorVetVisitTypeComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() vetDoctorVetVisitType: VetDoctorVetVisitType;
  @Input() vetineoVisitTypeBundle: VetineoVisitTypeBundle;
  @Input() clientSelected: Client;
  @Input() doctor: VetDoctor;
  @Input() vetClinic: VetClinic;

  titleOnEdit = 'Dostosuj typ wizyty dla pracownika';
  hasUnsavedChanges: boolean = false;
  maxTextAreaLength = 255;
  images: VImage[];
  isBusy: boolean;
  petSpecies: VetClinicPetSpecies[] = [];
  petSpeciesGroups: PetSpeciesGroup[];
  dataLoaded: boolean = false;
  private alertPresented: boolean = false;
  private previousTextAreaLength: number;

  fakturowniaTermsAccepted: boolean = false;
  selectedBundle: VetineoVisitTypeBundle;
  private vetcodeId: any;
  species: VetClinicPetSpecies[] = [];
  vetineoVisitTypeClientBundles: VetineoVisitTypeBundle[] = [];
  minutestoSelect: number[] = [];
  selectedMinutes: number = 0;
  private minimalKlinikaXpMinutes: number;
  useBundleSettings: boolean = true;
  allSpecies: boolean = true;
  tempSpecies: VetClinicPetSpecies[];
  showMinutes: boolean;
  clientId: number;
  tempSettings: VetDoctorVetVisitType;
  splitPetSpecies: boolean = false;
  private speciesServedByClinic: VetClinicPetSpecies[] = [];
  private speciesNotServedByClinic: VetClinicPetSpecies[] = [];
  cancellationHoursToSelect: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 24, 36, 48, 72, 96];
  maxTermCancellation: number;
  wasChecked: boolean = false;
  isCarePlan: boolean;
  bundlesSub: Subscription;
  subscriptions: Subscription = new Subscription();
  private vetDoctorVetVisitTypeCopy: VetDoctorVetVisitType;
  klinikaXpVisitTypeMinutes: number;
  isCancellationHoursValid: boolean;
  groupedSpecies: { group: PetSpeciesGroup; species: VetClinicPetSpecies[] }[];


  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetDoctorVetVisitTypeService: VetDoctorVetVisitTypeService,
    private vetClinicService: VetClinicService,
    private router: Router,
    private vetClinicPetSpeciesService: VetClinicPetSpeciesService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.vetDoctorVetVisitTypeCopy = {...this.vetDoctorVetVisitType}
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(
      this.vetClinicPetSpeciesService.getGlobalSpecies().pipe(
        tap(species => {
          if (species) {
            this.species = species;
            if (this.vetDoctorVetVisitType?.servedPetSpecies) {
              this.petSpecies = [...this.vetDoctorVetVisitType.servedPetSpecies];
            }
          }
          this.afterSelectClinic()
        }),
        switchMap(species => {
          return species ? this.vetClinicPetSpeciesService.getGlobalSpeciesGroups() : EMPTY;
        }),
        tap(groups => {
          if (groups) {
            this.petSpeciesGroups = groups;
            this.groupedSpecies = this.groupSpecies();
          }
        }),
        finalize(() => this.appStateService.updateIsBusySubject(false))
      ).subscribe()
    );

    this.componentTitle = 'Dostosuj konfigurację typu wizyty dla pracownika';
    this.actionBtnLabel = 'Dostosuj typ wizyty';
    this.actionQuestion = 'Na pewno chcesz dostosować typ wizyty dla pracownika?';
    this.actionSuccess = 'Typ wizyty został dostosowany';
    this.actionError = 'Wystąpił błąd podczas dostosowywania typu wizyty dla pracownika';
    this.formGroup = this.formBuilder.group({
      infoPL: [this.vetDoctorVetVisitType.infoPL ? this.vetDoctorVetVisitType.infoPL : ''],
      nameAdditionPL: [this.vetDoctorVetVisitType.nameAdditionPL, [Validators.maxLength(255)]]
    });

    this.allSpecies = this.vetDoctorVetVisitType.allPetSpecies;
    this.vetcodeId = this.vetDoctorVetVisitType.vetcodeId;
    this.clientId = this.vetDoctorVetVisitType.vClientId;
    this.useBundleSettings = this.vetDoctorVetVisitType.useBundleSettings;
    this.showMinutes = this.vetDoctorVetVisitType.showMinutes;
    this.selectedBundle = this.vetDoctorVetVisitType.vetineoVisitTypeBundle? this.vetDoctorVetVisitType.vetineoVisitTypeBundle : this.vetineoVisitTypeBundle;
    this.klinikaXpVisitTypeMinutes = this.vetDoctorVetVisitType.klinikaXpVisitTypeMinutes;

    this.appStateService.updateIsBusySubject(true);

    console.log(this.vetDoctorVetVisitType)


    if (this.doctor) {

      if (!this.vetDoctorVetVisitType?.useBundleSettings) {
        this.minutestoSelect = this.minutesAvailable(this.doctor.defaultVisitMinutes);
        if (this.vetDoctorVetVisitTypeMinutesAvailable(this.vetDoctorVetVisitType.minutes)) {
          this.selectedMinutes = this.vetDoctorVetVisitType.minutes;
        } else {
          this.selectedMinutes = this.doctor.defaultVisitMinutes;
        }
      } else {
        this.selectedMinutes = this.vetDoctorVetVisitType.minutes;
      }
      this.minimalKlinikaXpMinutes = this.calculateMinimalKlinikaXpMinutes(this.selectedMinutes, this.doctor.defaultVisitMinutes);
    }

    this.maxTermCancellation = this.vetDoctorVetVisitType.maxTermCancellation;
    this.isCancellationHoursValid = ((this.maxTermCancellation > 0) && (this.maxTermCancellation <= this.cancellationHoursToSelect[this.cancellationHoursToSelect.length - 1]));


    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    super.ngOnInit();
  }

  comparePets(o1, o2) {
    return o1 && o2 ? o1.uuid == o2.uuid : false;
  }

  @HostListener('document:keydown.escape')
  async onEsc() {
    const top = await this.modalController.getTop();
    if (top) await top.dismiss(undefined, 'escape');
  }

  handleVisitTypeMultimediaEnabledToggle(event: any) {
    this.vetDoctorVetVisitType.multimediaEnabled = !!event.detail.checked;
  }

  handleVisitTypePrepaidToggle(event: any) {
    this.vetDoctorVetVisitType.prepaidRequired = !!event.detail.checked;
  }

  handleVisitTypePrepaidPriceChange(event: any) {
    const price = (isNaN(event.detail.value) ? 0 : event.detail.value);
    if (price) {
      this.vetDoctorVetVisitType.prepaidPrice = price;
    }

    this.markUnsavedChanges();
  }


  onClose() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z edycji typów wizyt?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.modalController.dismiss(this.vetDoctorVetVisitTypeCopy, 'CLOSE');
      }, () => {
      });
    } else {
      this.modalController.dismiss(this.vetDoctorVetVisitTypeCopy, 'CLOSE');
    }
  }

  goTo(page: string) {
    this.router.navigateByUrl(page);
  }

  handleTextAreaKeyDown($event: KeyboardEvent) {
    let infoPL = this.formGroup.get("infoPL")?.value;
    this.previousTextAreaLength = infoPL?.length;
  }

  handleTextAreaKeyUp($event: KeyboardEvent) {
    let infoPL = this.formGroup.get("infoPL")?.value;
    if (infoPL?.length === this.maxTextAreaLength && this.previousTextAreaLength === infoPL?.length && !this.alertPresented) {
      this.alertPresented = true;
      const alertDuration = 3000;
      this.commonUtils.presentAlertToast('Osiągnięto maksymalną długość informacji.', alertDuration);
      setTimeout(() => {
        this.alertPresented = false;
      }, alertDuration);
    }
  }

  onAction() {
    this.wasChecked = true;
    if (!this.selectedMinutes) {
      this.commonUtils.presentAlertToast('Podaj czas trwania wizyty');
      return;
    }

    if (this.vetDoctorVetVisitType?.termCanBeCancelled && !this.maxTermCancellation) {
      this.commonUtils.presentAlertToast('Podaj maksymalny czas przed wizytą na dokonanie anulacji');
      return;
    }

    if (this.vetDoctorVetVisitType?.prepaidRequired && (this.vetDoctorVetVisitType?.prepaidPrice === undefined || this.vetDoctorVetVisitType?.prepaidPrice < 10)) {
      this.commonUtils.presentAlertToast(`Kwota przedpłaty dla wizyty nie może być większa niż 10`);
    } else {

      if (this.selectedBundle != null && this.doctor != null && (this.petSpecies?.length > 0 || this.allSpecies)) {
        this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
          let vetDoctorVetVisitTypeForm: VetDoctorVetVisitType = this.commonUtils.formGroupValuesToObject<VetDoctorVetVisitType>(new VetDoctorVetVisitType(), this.formGroup);
          this.vetDoctorVetVisitType.infoPL = vetDoctorVetVisitTypeForm.infoPL;
          this.vetDoctorVetVisitType.nameAdditionPL = vetDoctorVetVisitTypeForm.nameAdditionPL;
          this.vetDoctorVetVisitType.servedPetSpecies = this.petSpecies;
          this.vetDoctorVetVisitType.minutes = this.selectedMinutes;
          this.vetDoctorVetVisitType.multiplier = this.selectedMinutes / this.doctor.defaultVisitMinutes;

          this.vetDoctorVetVisitType.useBundleSettings = this.useBundleSettings;

          this.vetDoctorVetVisitType.vetDoctorUUID = this.doctor.uuid;
          this.vetDoctorVetVisitType.vetineoVetVisitTypeBundleUUID = this.selectedBundle.uuid;
          this.vetDoctorVetVisitType.allPetSpecies = this.allSpecies;
          this.vetDoctorVetVisitType.showMinutes = this.showMinutes;
          if (this.vetDoctorVetVisitType.termCanBeCancelled) {
            this.vetDoctorVetVisitType.maxTermCancellation = this.maxTermCancellation;
          }
          this.vetDoctorVetVisitType.vClientId = this.clientSelected.id;
          if (this.klinikaXpVisitTypeMinutes === undefined) {
            this.klinikaXpVisitTypeMinutes = null;
          }
          this.vetDoctorVetVisitType.klinikaXpVisitTypeMinutes = this.klinikaXpVisitTypeMinutes;
          this.vetDoctorVetVisitType.vetcodeId = this.vetClinic.vetcodeId;
          this.vetDoctorVetVisitType.vetineoVisitTypeBundle = null;
          this.appStateService.updateIsBusySubject(true);
          this.registerSubscription(this.vetDoctorVetVisitTypeService.updateVetDoctorVetVisitType(this.vetDoctorVetVisitType).subscribe(r => {
            if (r) {
              this.modalController.dismiss(r, this.action);
              this.appStateService.updateIsBusySubject(false);

            } else {
              this.appStateService.updateIsBusySubject(false);
              this.commonUtils.presentAlertToast("Wystąpił błąd podczas zapisu konfiguracji typu wizyty dla pracownika");
            }
          }, error => {
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas zapisu konfiguracji typu wizyty dla pracownika");
            console.log(error)
            this.appStateService.updateIsBusySubject(false);
          }));


        }, () => {
        });
      } else {
        this.commonUtils.presentAlertToast('Wybór obsługiwanych gatunków zwierząt jest niezbędny do zapisania');
      }
    }
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }


  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
    if (this.bundlesSub) {
      this.bundlesSub.unsubscribe();
    }

  }


  private afterSelectClinic() {
    this.appStateService.updateIsBusySubject(true);
    this.vetClinicService.checkIfFakturowniaAccepted(this.vetClinic.uuid).subscribe(cl => {
      if (cl && cl.fakturowniaApproved) {
        this.fakturowniaTermsAccepted = true;
      }
      this.dataLoaded = true;
      this.appStateService.updateIsBusySubject(false);
    });

    console.log(this.vetClinic.servedPetSpeciesKeys)

    if (this.vetClinic?.servedPetSpeciesKeys && !this.vetClinic?.allPetSpecies) {
      const servedPetSpecies = JSON.parse(this.vetClinic.servedPetSpeciesKeys);
      console.log(servedPetSpecies);
      this.species.forEach(sp => {
        if (servedPetSpecies.filter(e => e === sp.key)[0]) {
          this.speciesServedByClinic.push(sp);
        } else {
          this.speciesNotServedByClinic.push(sp);
        }
      });

      this.splitPetSpecies = true;
    }
  }

  getSpecies() {
    return this.species;
  }

  private minutesAvailable(minutes: number): number[] {
    if (minutes) {
      return Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number" && (value % minutes) === 0) as number[];
    } else {
      return [];
    }
  }


  onSelectMinutes($event) {
    this.selectedMinutes = $event.detail.value;
    this.vetDoctorVetVisitType.minutes = this.selectedMinutes;
    this.minimalKlinikaXpMinutes = this.calculateMinimalKlinikaXpMinutes(this.selectedMinutes, this.doctor.defaultVisitMinutes);
    if (this.klinikaXpVisitTypeMinutes && (this.klinikaXpVisitTypeMinutes < this.minimalKlinikaXpMinutes || this.klinikaXpVisitTypeMinutes > this.selectedMinutes)) {
      this.klinikaXpVisitTypeMinutes = undefined;
    }
  }

  onSelectKlinikaXPMinutes($event) {
    this.klinikaXpVisitTypeMinutes = $event.detail.value;
    this.vetDoctorVetVisitType.klinikaXpVisitTypeMinutes = this.klinikaXpVisitTypeMinutes;
  }

  onChangeUseCustom($event) {
    if (this.vetDoctorVetVisitType.useBundleSettings !== $event.detail.checked) {
      if (this.useBundleSettings && this.selectedBundle) {
        this.tempSettings = this.vetDoctorVetVisitType;
        let vdvvtFromBundle = VetineoVisitTypeBundle.asVetDoctorVetVisitType(this.selectedBundle);
        this.vetDoctorVetVisitType.infoPL = vdvvtFromBundle.infoPL;
        this.vetDoctorVetVisitType.communicationToolsEnabled = vdvvtFromBundle.communicationToolsEnabled;
        this.vetDoctorVetVisitType.prepaidPrice = vdvvtFromBundle.prepaidPrice;
        this.vetDoctorVetVisitType.prepaidRequired = vdvvtFromBundle.prepaidRequired;
        this.vetDoctorVetVisitType.nameAdditionPL = vdvvtFromBundle.nameAdditionPL;
        this.vetDoctorVetVisitType.namePL = vdvvtFromBundle.namePL;
        this.vetDoctorVetVisitType.multiplier = vdvvtFromBundle.multiplier;
        this.vetDoctorVetVisitType.multimediaEnabled = vdvvtFromBundle.multimediaEnabled;
        this.vetDoctorVetVisitType.servedPetSpecies = vdvvtFromBundle.servedPetSpecies;
        this.vetDoctorVetVisitType.maxTermCancellation = vdvvtFromBundle.maxTermCancellation;
        this.vetDoctorVetVisitType.termCanBeCancelled = vdvvtFromBundle.termCanBeCancelled;
        this.vetDoctorVetVisitType.requireCancellationReason = vdvvtFromBundle.requireCancellationReason;
        this.petSpecies = vdvvtFromBundle.servedPetSpecies;
        if (vdvvtFromBundle.minutes) {
          this.vetDoctorVetVisitType.minutes = vdvvtFromBundle.minutes;
          this.selectedMinutes = vdvvtFromBundle.minutes;
        }
        this.formGroup = this.formBuilder.group({
          infoPL: [this.vetDoctorVetVisitType.infoPL],
          nameAdditionPL: [this.vetDoctorVetVisitType.nameAdditionPL, [Validators.maxLength(40)]]
        });

        this.allSpecies = vdvvtFromBundle.allPetSpecies;
        if (this.allSpecies) {
          this.petSpecies = [];
        }
      } else {
        if (this.doctor) {
          this.minutestoSelect = this.minutesAvailable(this.doctor.defaultVisitMinutes);
          if (this.vetDoctorVetVisitTypeMinutesAvailable(this.vetDoctorVetVisitType.minutes)) {
            this.selectedMinutes = this.vetDoctorVetVisitType.minutes;
          } else {
            this.selectedMinutes = this.doctor.defaultVisitMinutes;
          }
        }
      }

      console.log(this.selectedMinutes)
    }

  }

  dataIsNotProvided() {
    return !(this.selectedBundle && this.selectedMinutes && (this.petSpecies?.length > 0 || this.allSpecies) && this.doctor) || (!this.isCancellationHoursValid && this.vetDoctorVetVisitType.termCanBeCancelled)
  }

  onAllSpeciesChange($event) {
    if ($event.detail.checked) {
      this.tempSpecies = this.petSpecies;
      this.petSpecies = [];
    } else {
      this.petSpecies = this.tempSpecies;
    }
  }

  onSelectShowMinutes($event) {
    this.showMinutes = !!$event.detail.checked;
  }

  getBundleName(bundle: VetineoVisitTypeBundle) {
    let name = '';
    if (bundle.nameAdditionPL) {
      name = `${bundle?.namePL} ${bundle.nameAdditionPL}`;
    } else {
      name = bundle?.namePL;
    }

    if (bundle.isCarePlan) {
      name = name + ' (abonament)';
    }

    return name;
  }

  getDoctorName(doc: VetDoctor) {
    if (doc.defaultVisitMinutes) {
      return doc.name;
    } else {
      return doc.name + ' (ustaw czas standardowy)';
    }
  }

  getSpeciesServed() {
    return this.speciesServedByClinic;
  }

  getSpeciesServedNotServed() {
    return this.speciesNotServedByClinic;
  }

  getSplitSpecies() {
    return this.splitPetSpecies;
  }

  handleEditTermCanBeCancelledToggle($event) {
    this.vetDoctorVetVisitType.termCanBeCancelled = !!$event.detail.checked;
  }

  handleRequreCancellationReasonToggle($event) {
    this.vetDoctorVetVisitType.requireCancellationReason = !!$event.detail.checked;
  }

  onSelectHoursToCancellation($event) {
    this.maxTermCancellation = $event.detail.value;
  }

  private vetDoctorVetVisitTypeMinutesAvailable(minutes: number) {
    return this.minutesAvailable(this.doctor.defaultVisitMinutes)?.filter(e => e == minutes)[0];
  }

  getLength() {
    let infoPL = this.formGroup?.get("infoPL")?.value;
    if (infoPL) {
      return this.maxTextAreaLength - infoPL?.length;
    } else {
      return this.maxTextAreaLength
    }
  }

  getKlinikaXpAvailableMinutes(number) {
     let numbers = Array.from({length: this.selectedMinutes - this.minimalKlinikaXpMinutes}, (_, i) => i + 1 + this.minimalKlinikaXpMinutes);
     if (!numbers.includes(number)) {
       numbers.push(number);
     }
     return numbers;
  }

  private calculateMinimalKlinikaXpMinutes(selectedMinutes: number, defaultDoctorMinutes: number) {
    const numberOfTimeSlots = Math.ceil(selectedMinutes / defaultDoctorMinutes);
    return (numberOfTimeSlots - 1) * defaultDoctorMinutes;
  }

  getSelectedSpeciesText(): string {
    if (!this.petSpecies || this.petSpecies.length === 0) {
      return '';
    }
    return this.petSpecies.map(sp => sp.name).join(', ');
  }

  isSpeciesSelected(species: VetClinicPetSpecies): boolean {
    if (!this.petSpecies) return false;
    return this.petSpecies.some(selected => selected.key === species.key);
  }

  toggleSpecies(species: VetClinicPetSpecies, event: any) {
    const isChecked = event.detail.checked;

    if (!this.petSpecies) {
      this.petSpecies = [];
    }

    if (isChecked) {
      if (!this.isSpeciesSelected(species)) {
        this.petSpecies.push(species);
      }
    } else {
      this.petSpecies = this.petSpecies.filter(selected => selected.key !== species.key);
    }
  }

  onChangeHoursToCancellation(event: any) {
    const value = Math.floor(Number(event.detail.value));
    this.isCancellationHoursValid = ((value > 0) && (value <= this.cancellationHoursToSelect[this.cancellationHoursToSelect.length - 1]));
    if (this.isCancellationHoursValid) {
      this.maxTermCancellation = value;
      console.log(this.maxTermCancellation);
    }
  }
  groupSpecies(): {group: PetSpeciesGroup, species: VetClinicPetSpecies[]}[] {
    const speciesByCode = this.species.reduce((acc, sp) => {
      if (!acc[sp.groupCode]) {
        acc[sp.groupCode] = [];
      }
      acc[sp.groupCode].push(sp);
      return acc;
    }, {} as Record<string, VetClinicPetSpecies[]>);
    const grouped = this.petSpeciesGroups.map(group => ({
      group: group,
      species: speciesByCode[group.code] || []
    }));
    return grouped.sort((a, b) => a.group.orderIdx - b.group.orderIdx);
  }

  async onSelectSpeciesClick() {

    const modal = await this.modalController.create({
      component: SelectSpeciesModalComponent,
      componentProps: {
        petSpecies: this.petSpecies,
        groupedPetSpecies: this.groupedSpecies,
        onModalSave: (updatedSpecies: VetClinicPetSpecies[]) => {
          this.petSpecies = updatedSpecies;
        }
      },
      cssClass: ['stacked-modal', 'wide-modal']
    });

    return await modal.present();
  }
}
